import { useSuspenseQuery } from '@tanstack/react-query';

import { Content } from '@/core/components';

import { ProofAction } from '@feature/proof/ProofAction';
import { ProofUploadRequest } from '@feature/proof/ProofTypes';
import { Author, Id } from '@feature/utils';

import {
  getProjectProofsOptions,
  useDeleteProjectProof,
  useUploadOrUpdateProjectProof,
} from './model/ProjectProofModel';

interface ProjectProofActionProps {
  projectId: number;
  authors: Author[];
  variant?: 'compact';
}

export function ProjectProofAction({ projectId, authors }: ProjectProofActionProps) {
  const { data: proofs } = useSuspenseQuery(getProjectProofsOptions(projectId));
  const uploadOrUpdateMutation = useUploadOrUpdateProjectProof(projectId);
  const deleteMutation = useDeleteProjectProof(projectId);

  const handleUpload = (request: ProofUploadRequest) => {
    uploadOrUpdateMutation.mutate(request);
  };

  const handleDelete = (proofId: Id) => {
    deleteMutation.mutate(proofId);
  };

  return (
    <Content type="full">
      <ProofAction
        proofs={proofs}
        entity="project"
        onUpload={handleUpload}
        onDelete={handleDelete}
        isPending={uploadOrUpdateMutation.isPending || deleteMutation.isPending}
        authors={authors}
      />
    </Content>
  );
}
